// **********************************************************
// Open mega menu in mobile
// **********************************************************
attachEvent('.menu__arrow', 'click', (ev) => {
  if (windowWidth() < breakpointMd) {
    const menuParent = ev.target.closest('.menu');
    const arrowParent = ev.target.closest('.menu__item');
    arrowParent.classList.toggle('is-open-submenu');
    menuParent.classList.toggle('sub-open');
  }
});

// **********************************************************
// Close mega menu in mobile
// **********************************************************
attachEvent('.mage-menu__back-title', 'click', (ev) => {
  const menuParent = ev.target.closest('.menu');
  const parentElem = ev.target.closest('.menu__item');
  parentElem.classList.remove('is-open-submenu');
  menuParent.classList.remove('sub-open');
});
